import { USER_PLAN_API } from 'modules/profile/user-plan/api/user-plan-api'
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export function useUserPlan(isFetchAllowed: boolean = true) {
  const { user, isWorkspaceOwner, isCustomer } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, UseUserPlanInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: userPlanData, mutate } = useControlledSwr(
    () => {
      if (user && isCustomer && isWorkspaceOwner) {
        return [USER_PLAN_API, user.dashboardLocale]
      }
      return null
    },
    fetcher,
    undefined,
    isFetchAllowed,
  )

  return { userPlanData, mutate }
}
